import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import CurrentAssetBalanceFilters from "./components/CurrentAssetBalanceFilters";
import CurrentAssetBalanceTable from "./components/CurrentAssetBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { exportCurrentAssetBalanceCsv } from "./components/exportCurrentAssetBalanceCsv";

const { Title } = Typography;

const CurrentAssetBalance = () => {
    const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, total_balance } = useSelector( // ← added list, total_balance
    (state) => state.currentAssetBalance
  );
  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Current Asset Balance Report",
    removeAfterPrint: true,
  });
 // ← added
  const handleDownloadCsv = () => {
    exportCurrentAssetBalanceCsv({
      list,
      total_balance,
      filters,
      title:    "Current Asset Balance Report",
      filename: "current_asset_balance_report",
    });
  };

  const hasData = list.length > 0; 
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/reports")}
        style={{ marginRight: 8 }}
      />
          <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Current Asset Balance Report</Title>
          </div>}
         extra={
            // ← replaced single Button with Flex + two buttons
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
        }}
        />

        <CurrentAssetBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CurrentAssetBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Current Asset Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <CurrentAssetBalanceTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default CurrentAssetBalance;
